function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { arrayOf, shape, func, object, string } from 'prop-types';
import clsx from 'clsx';
import { List, ListItem } from '@mui/material/';
import { styled } from '@mui/material/styles';
const StyledList = styled(List)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    background: palette.background.default,
    padding: "".concat(spacing(), " ").concat(spacing(2))
  };
});
const StyledListItem = styled(ListItem)(_ref2 => {
  let {
    theme: {
      palette,
      spacing,
      typography
    }
  } = _ref2;
  return {
    borderBottomColor: palette.divider,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    fontSize: typography.body1.fontSize,
    height: spacing(6),
    padding: 0,
    '&:last-of-type': {
      borderBottomWidth: 0
    }
  };
});
const renderRows = (rowRenderer, data, classes) => data.map((entry, index) => /*#__PURE__*/React.createElement(StyledListItem
// eslint-disable-next-line react/no-array-index-key
, {
  key: index,
  className: clsx('sovosList__item', classes === null || classes === void 0 ? void 0 : classes.row)
}, rowRenderer(entry)));

/**
 * Unlike the Material UI `List`, this component does not take children.
 * Instead, child list items are generated based on `data` and `rowRender` props.
 */
const SovosList = _ref3 => {
  let {
    data,
    sortFunction,
    classes,
    className,
    rowRenderer,
    ...props
  } = _ref3;
  let sortedData = data;
  if (typeof sortFunction === 'function') {
    sortedData = sortedData.slice().sort(sortFunction);
  }
  const rows = renderRows(rowRenderer, sortedData, classes);
  return /*#__PURE__*/React.createElement(StyledList, _extends({
    className: clsx('sovosList', classes === null || classes === void 0 ? void 0 : classes.root, className)
  }, props), rows);
};
SovosList.propTypes = {
  /**
   * Data provided to the getRows function.
   */
  data: arrayOf(shape).isRequired,
  /**
   * Function used to get the row items.
   */
  rowRenderer: func.isRequired,
  /**
   * Function used to sort provided data
   */
  sortFunction: func,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosList.baseComponent = {
  name: 'List',
  link: 'list/'
};
export default SovosList;